import { createStore } from "zustand/vanilla";

export interface GlobalSearchScope {
  /**
   * The mailbox id currently selected in the Email module's sidebar. The
   * Email adapter appends this as `&mailbox=<id>` when present so global
   * search results match what the user sees in the inbox.
   *
   * `null` means no scope has been published yet (Email module never
   * mounted, or unmount cleanup ran). The Email adapter falls back to its
   * default user-wide behaviour in that case.
   *
   * Future hooks (documented, not implemented this round):
   *   visibleCalendarIds?: string[];  // Planner scoping
   */
  emailMailboxId: string | null;
}

export const globalSearchScopeStore = createStore<GlobalSearchScope>(() => ({
  emailMailboxId: null,
}));

export function setEmailMailboxScope(id: string | null): void {
  globalSearchScopeStore.setState({ emailMailboxId: id });
}
